import { Switch, HashRouter, Route, Redirect } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import Home from '@/pages/Home';
import Backend from '@/pages/Backend';
import Layout from '@/components/Layout';
import ScreenLoading from '@/components/ScreenLoading';
import IntlWrapper from '@/Intl';

message.config({
  maxCount: 1,
});

function App() {
  return (
    <IntlWrapper>
      <ConfigProvider
        getPopupContainer={(el) => {
          return el || document.body;
        }}
      >
        <HashRouter>
          <ScreenLoading>
            <Layout>
              <Switch>
                <Route exact path='/' component={Home} />
                <Route exact path='/:product/:part' component={Backend} />
                <Route component={() => <Redirect to='/' />} />
              </Switch>
            </Layout>
          </ScreenLoading>
        </HashRouter>
      </ConfigProvider>
    </IntlWrapper>
  );
}

export default App;
